// #BR#241	 - Mbeng - KNEt payment redirect page - 19/10/2026	
<template>
  <div>
  <Header class="responsive-bar">
      <template v-slot:title>
        
      </template>
    </Header>
  <div class="knet-payment-page">
    <div class="payment-message">
      {{$t("payment-transaction-is-processed")}}
    </div>
  </div>
  </div>
</template>
<script>

import Header from "@/components/Header";

export default {
  name: "KnetPayment",
  components: {
    Header,
  }


};
</script>

<style scoped>
.knet-payment-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;
}

.payment-message {
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #333;
}
</style>